import * as mlbPartnersLoadCoordinators from './load'
import * as mlbMenuItemCoordinators from './menuItem'
import * as mlbEditOrdersCoordinators from './editOrders'

export default Object.freeze({
  ...mlbMenuItemCoordinators,
  ...mlbEditOrdersCoordinators,
  ...mlbPartnersLoadCoordinators,
})
